import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// File-like paths (pdf, xml, images...) are real files, not SPA routes
const FILE_PATH = /\.[a-z0-9]{2,5}$/i;

// Converts clicks on internal <a href> links into SPA navigation,
// so the page transition runs instead of a full browser reload.
// Opt out for any link with data-no-spa or rel="external".
const LinkInterceptor = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const onClick = (e) => {
            if (e.defaultPrevented || e.button !== 0) return;
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

            const a = e.target.closest && e.target.closest("a[href]");
            if (!a) return;
            if (a.target && a.target !== "_self") return;
            if (a.hasAttribute("download") || a.hasAttribute("data-no-spa"))
                return;
            if ((a.getAttribute("rel") || "").includes("external")) return;

            // getAttribute: `a.href` is an object for SVG <a> elements
            const raw = a.getAttribute("href");
            if (!raw) return;
            let url;
            try {
                url = new URL(raw, window.location.href);
            } catch {
                return;
            }
            if (url.origin !== window.location.origin) return; // external, mailto:, tel:
            if (FILE_PATH.test(url.pathname)) return; // let the browser fetch real files

            const samePage =
                url.pathname === window.location.pathname &&
                url.search === window.location.search;
            if (samePage) {
                if (!url.hash) e.preventDefault(); // avoid a pointless reload
                return;
            }

            e.preventDefault();
            navigate(url.pathname + url.search + url.hash);
        };

        // capture phase: runs before the popout's onClose unmounts the link
        document.addEventListener("click", onClick, true);
        return () => document.removeEventListener("click", onClick, true);
    }, [navigate]);

    return null;
};

export default LinkInterceptor;
